<template>
  <div class="sidebarArray" v-if="container && element.length">

    <div class="property-input" :class="{selected: isSelected}">
        <div class="property-header">
            <div class="property-header-left">
                <label class="property-label">
                    {{ property.text }}
                    <tooltip v-if="property.tooltip" :text="property.tooltip"/>
                </label>
            </div>

            <!-- Bouton Expension -->
            <span v-if="element && element.length > 0" class="property-toggle-icon" @click="isExpand = !isExpand" :class="{ 'expanded': isExpand }">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
            </span>
        </div>
        <div class="property-content" v-show="isExpand">
            <div class="property-element" :class="{selected: currentElementIndex == el.previewId}" v-for="(el, index) in element" :key="index" @click="setSelectedElement(el.previewId)">
              <div class="property-element-name">{{ el.Name }}</div>
              <!-- Bouton visible-->
              <button class="short-button" title="Options" @click="updateProperty({element: el, property: {name: 'Show'}, value: !el.Show})">
                <svg xmlns="http://www.w3.org/2000/svg" class="short-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                  <line v-if="!el.Show" x1="1" y1="23" x2="23" y2="1" stroke-width="2"/>
                </svg>
              </button>
              <!-- Bouton options -->
              <button v-if="hasOption(el, index)" class="short-button" title="Options" @click="contextMenuElementSelect($event, el, index)">
                <svg xmlns="http://www.w3.org/2000/svg" class="short-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="1" />
                  <circle cx="12" cy="5" r="1" />
                  <circle cx="12" cy="19" r="1" />
                </svg>
              </button>
            </div>
        </div>
    </div>
    <DeleteConfirmPopup
      :show="showDeleteConfirm"
      :elementName="contextMenuElement?.Name ? contextMenuElement.Name : ''"
      @close="showDeleteConfirm = false"
      @confirm="confirmDelete"
    />
    <NameElementPopup :show="showNameEdit" :defaultName="contextMenuElement?.Name ? contextMenuElement.Name : ''" @close="showNameEdit = false" @named="changeName"/>
    <context-menu v-model:show="contextMenuShow" :options="contextMenuComponent">
      <context-menu-item v-if="contextMenuElement.CanChangeName" @click="showNameEdit = true">
        <template #icon>
          <textIcon/>
        </template>
        <template #label>
          Modifier le nom
        </template>
      </context-menu-item>
      <context-menu-item v-if="canBeUpped" @click="changePosition(-1)">
        <template #icon>
          <upperIcon/>
        </template>
        <template #label>
          Monter
        </template>
      </context-menu-item>
      <context-menu-item v-if="canBeLowered" @click="changePosition(1)">
        <template #icon>
          <lowerIcon/>
        </template>
        <template #label>
          Descendre
        </template>
      </context-menu-item>
      <context-menu-item v-if="contextMenuElement.CanBeDuplicate" @click="duplicate()">
        <template #icon>
          <copyIcon/>
        </template>
        <template #label>
          Dupliquer l'élément
        </template>
      </context-menu-item>
      <context-menu-item v-if="contextMenuElement.CanBeRemove" @click="showDeleteConfirm = true; contextMenuShow = false;">
        <template #icon>
          <deleteIcon/>
        </template>
        <template #label>
          Supprimer l'élément
        </template>
      </context-menu-item>
    </context-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as namespaceStore from "../../../vuexStore/namespaceStore.js"
import * as actions from "../../../vuexStore/actions.js"
import DeleteConfirmPopup from '../../PopupComponents/DeleteConfirmPopup.vue'
import NameElementPopup from '../../PopupComponents/NameElementPopup.vue'
import textIcon from "../../IconComponents/textIcon.vue"
import upperIcon from "../../IconComponents/upperIcon.vue"
import lowerIcon from "../../IconComponents/lowerIcon.vue"
import deleteIcon from "../../IconComponents/deleteIcon.vue"
import copyIcon from "../../IconComponents/copyIcon.vue"
import tooltip from '../../Tooltip.vue'

export default {
  name: 'Array',
  props: {
    labeled: {
      type: Boolean,
      default: true
    },
    property: {
      type: [Object, null],
      required: true
    },
    element: {
      type: [Array, null],
      required: true
    },
    container: {
      type: [Object, null],
      required: true
    }
  },
  emits: [
  ],
  components: {
    DeleteConfirmPopup,
    NameElementPopup,
    textIcon,
    upperIcon,
    lowerIcon,
    deleteIcon,
    copyIcon,
    tooltip
  },
  data() {
    return {
      isExpand: false,
      showNameEdit: false,
      contextMenuElement: undefined,
      indexContextMenuElement: undefined,
      showDeleteConfirm: false,
      contextMenuShow: false,
      contextMenuComponent: {
        zIndex: 3,
        minWidth: 230,
        x: 0,
        y: 0
      },
    }
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'currentElementIndex',
    ]),
    canBeUpped: function() {
      if (!this.contextMenuElement || this.element.length == 0 || this.indexContextMenuElement == 0 || !this.contextMenuElement.CanBeMove) return false;
      return true;
    },
    canBeLowered: function() {
      if (!this.contextMenuElement || this.element.length == 0 || this.indexContextMenuElement >= this.element.length - 1 || !this.contextMenuElement.CanBeMove) return false;
      return true;
    },
    isSelected: function() {
        if (this.currentElementIndex && this.element) {
            return this.element.some(el => {
              return el.previewId == this.currentElementIndex;
            });
        }
        return false;
    }
  },
  watch: {
    currentElementIndex() {
      // if (this.isExpand == true && !this.currentElementIndex)
      //   return;
      if (this.isSelected)
        this.isExpand = true;
      // else
      //     this.isExpand = false;
    }
  }, 
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'setSelectedElement': actions.SET_SELECTED_ELEMENT,
      'changeOrder': actions.UPDATE_ORDER_PROPERTY,
      'updateProperty': actions.UPDATE_PROPERTY,
      'actionRemoveElement': actions.REMOVE_PAGE_ELEMENT,
      'addElementAction': actions.ADD_ELEMENT
    }),
    hasOption: function(el, index) {
      return el.CanChangeName || el.CanBeDuplicate || el.CanBeRemove || (
        el.CanBeMove && (!this.element.length == 0 && index != 0 && index >= this.element.length - 1)
      )
    },
    changeName: function(text) {
      this.updateProperty({element: this.contextMenuElement, property: {name: "Name"}, value: text});
      this.showNameEdit = false;
    },
    contextMenuElementSelect: function(event, el, index) {
      this.indexContextMenuElement = index;
      this.contextMenuElement = el;
      this.contextMenuShow = true;
      this.contextMenuComponent.x = event.x;
      this.contextMenuComponent.y = event.y;
    },
    changePosition: function(ch) {
      this.changeOrder({index: this.indexContextMenuElement, move: ch, property: this.property});
      this.indexContextMenuElement = undefined;
      this.contextMenuElement = undefined;
      this.contextMenuShow = false;
    },
    duplicate: function() {
      this.addElementAction({
        target: this.property.name,
        toAdd: this.contextMenuElement.constructor.fromObject(this.contextMenuElement.toObject(true)),
        element: null
      });
    },
    confirmDelete() {
      this.actionRemoveElement(this.contextMenuElement.previewId);
      this.showDeleteConfirm = false;
    },
  }
}
</script>

<style scoped>
.short-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
  transition: all 0.2s ease;
  padding: 0;
}
.short-icon {
  width: 1rem;
  height: 1rem;
}

.short-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.short-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.array-label {
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
}

.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
}

.property-input.selected {
    border: 1px solid #3b82f6;
}

.property-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
  gap: 10px;
}

.property-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.property-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.property-toggle-icon {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  justify-content: center;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
  transition: all 0.2s ease;
  padding: 0;
}

.property-toggle-icon:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.property-toggle-icon:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.property-toggle-icon.expanded {
  transform: rotate(90deg);
}

.property-element-name {
  flex: 1;
}

.property-element {
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding: 0.25rem;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 0.375rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #e5e7eb;
    cursor: pointer;
}

.property-element.selected {
    background-color: rgba(59, 130, 246, 0.4);
}
</style>